<template>
  <section
    :style="data.style ? data.style :  isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
  >
    <v-container class="py-12">
      <v-row justify="space-around">
        <v-col cols="12" md="6" lg="4">
          <v-text-field label="Title" @change="onChange" v-model="data.title" :dark="isDark"></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" md="6" lg="3">
          <v-text-field
            label="Month label"
            :dark="isDark"
            @change="onChange"
            v-model="data.cycle_labels.month"
            prepend-icon="far fa-circle"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="3">
          <v-text-field
            label="Year label"
            @change="onChange"
            :dark="isDark"
            v-model="data.cycle_labels.year"
            prepend-icon="far fa-circle"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" sm="6" md="6" lg="5" xl="3" class v-for="(item,i) in data.items" :key="i">
          <v-card class="tile">
            <v-container class="py-6 white--text" :style="item.title_style">
              <v-text-field label="Title" @change="onChange" v-model="item.title" dark></v-text-field>
              <v-text-field label="Style" @change="onChange" v-model="item.title_style" dark></v-text-field>
              <div>
                <v-checkbox
                  v-model="item.best_value"
                  dark
                  @change="onChange"
                  :true-value="true"
                  :false-value="false"
                  label="Best Value"
                ></v-checkbox>
              </div>
              <div class="ribbon ribbon-top-right" v-if="item.best_value">
                <span>Best Value</span>
              </div>
            </v-container>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" class="text-center">
                  <div>
                    <v-text-field
                      v-model="item.cycle.month.price"
                      @change="onChange"
                      label="Monthly Price"
                    ></v-text-field>
                    <v-text-field
                      v-model="item.cycle.month.save"
                      @change="onChange"
                      label="Monthly Savings"
                    ></v-text-field>
                  </div>
                  <div>
                    <v-text-field
                      v-model="item.cycle.year.price"
                      @change="onChange"
                      label="Yearly Price"
                    ></v-text-field>
                    <v-text-field
                      v-model="item.cycle.year.save"
                      @change="onChange"
                      label="Yearly Savings"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container style="height:530px">
              <v-row>
                <v-col cols="12">
                  <vue-editor
                    @text-change="onChangeEditor"
                    v-model="item.features"
                    style="height:375px"
                  />
                </v-col>
              </v-row>
            </v-container>

            <v-container class="py-2 grey lighten-4">
              <v-text-field label="Button text" @change="onChange" v-model="item.button.text"></v-text-field>
              <v-text-field label="Button url" @change="onChange" v-model="item.button.url"></v-text-field>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-container class>
        <v-row justify="center">
          <v-col cols="12" md="8" lg="6">
            <v-text-field
              label="Button text"
              :dark="isDark"
              @change="onChange"
              v-model="data.footer_button.text"
            ></v-text-field>
            <v-text-field
              label="Button url"
              :dark="isDark"
              @change="onChange"
              v-model="data.footer_button.url"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-divider></v-divider>
    <v-container class="grey lighten-3">
      <v-row>
        <v-col cols="12">
          <v-switch
            label="Dark"
            dense
            @change="onChange"
            hide-details
            class="my-0 py-0"
            color="primary"
            v-model="data.dark"
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Class" @change="onChange" v-model="data.class"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field dense label="Style" @change="onChange" v-model="data.style"></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import sections from "@/assets/sections.json";
export default {
  name: "PagePricingEdit",
  props: ["value"],
  data() {
    return {
      cycle: "month",
      prices: {
        standard: { month: 11, year: 111, save: 11 },
        plus: { month: 22, year: 222, save: 22 }
      }
    };
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  },
  methods: {
    onChange() {
      this.$emit("change");
    },
    removeTile(tile) {
      if (!confirm("Remove item ?")) {
        return;
      }

      this.data.tiles.splice(this.data.tiles.indexOf(tile), 1);
      this.onChange();
    },
    addTile() {
      let tile = sections.find(s => {
        return s.type === "pricing";
      });

      this.data.items.push({ ...tile.data.items[0] });
      this.onChange();
    },
    onChangeEditor(delta, oldDelta) {
      //console.log("pricing edit delta ", JSON.stringify(delta));
      //console.log("pricing edit oldDelta", JSON.stringify(oldDelta));
      if (oldDelta.ops[0].insert !== "\n") {
        if (oldDelta.ops.length !== delta.ops.length) {
          this.onChange();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tile {
  -webkit-transition: 0.2s ease;
  -moz-transition: 0.2s ease;
  -o-transition: 0.2s ease;
  transition: 0.2s ease;
}

.tile:hover {
  transform: translateY(-5px);
  -webkit-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  -moz-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
}
/* common */
.ribbon {
  width: 130px;
  height: 130px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 0px 0;
  background-color: #000000;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 12px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top right*/
.ribbon-top-right {
  top: 0px;
  right: 0px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 25px;
  transform: rotate(45deg);
}

.plus-gradient {
  background: rgb(0, 187, 236);
  background: linear-gradient(
    135deg,
    rgba(0, 187, 236, 1) 0%,
    rgba(79, 209, 245, 1) 50%,
    rgba(144, 84, 255, 1) 100%
  );
}
</style>